import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthActions, SuperStore } from '@bilancio/root-store';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ReloadUserPermitsInterceptor implements HttpInterceptor {
  constructor(private readonly store: SuperStore) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.store.dispatch(AuthActions.loadUserPermission({ showToast: true }));
        }

        throw error;
      }),
    );
  }
}
